import { initCustomVideoPlayButton } from './custom-video-play-button.js';
import { initElementorVideoLightbox } from './elementor-video-lightbox.js';
import { initBackgroundVideo } from './background-video.js';
import { initProjectPopup } from './project-popup.js';
import { initLeadSourceCapture, initLeadSourceApply } from './lead-source.js';
import { initQueryForwarding } from './query-forwarding.js';
import { initGravityFormsRecaptchaFix } from './gravity-forms-recaptcha.js';
import { initFullscreenHeaderFix } from './fullscreen-header-fix.js';

(function ($) {

    document.addEventListener('DOMContentLoaded', function () {
        initCustomVideoPlayButton();
        initElementorVideoLightbox();
        initBackgroundVideo();
        initProjectPopup();
        initLeadSourceCapture();
        initLeadSourceApply();
        initQueryForwarding();
        initGravityFormsRecaptchaFix();
        initFullscreenHeaderFix();
    });

})(jQuery);
